import { DEFAULT_VEHICLE_SUBSCRIPTION_FILTER } from 'constants/common'
import { getUniqueItem, replaceValueAtPath } from 'helpers/utils'
import UserTypes from 'store/actionTypes/user'
import VehicleTypes from 'store/actionTypes/vehicle'
import VehicleElectronicKeyTypes from 'store/actionTypes/vehicleElectronicKey'

const initialData = {
  info: {},
  error: null,
  list: [],
  pagination: {},
  filter: {},
  current: {},
  electronicKeys: {
    list: [],
    pagination: {}
  },
  subscriptions: {
    list: [],
    filter: DEFAULT_VEHICLE_SUBSCRIPTION_FILTER
  },
  users: {
    list: []
  },
  directVehicle: {
    list: [],
    pagination: {}
  },
  systems: []
}

const vehicle = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case VehicleTypes.GET_VEHICLES_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case VehicleTypes.GET_VEHICLE_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case VehicleTypes.UPDATE_FILTER_VEHICLE_SUCCESS:
      return { ...state, filter: payload }
    case VehicleElectronicKeyTypes.GET_VEHICLE_ELECTRONIC_KEYS_SUCCESS:
      if (payload?.meta.currentPage === 1) {
        return {
          ...state,
          electronicKeys: {
            list: payload?.items,
            pagination: payload?.meta
          }
        }
      }
      return {
        ...state,
        electronicKeys: {
          list: getUniqueItem([
            ...(state.electronicKeys.list || []),
            ...(payload?.items || [])
          ]),
          pagination: payload?.meta
        }
      }
    case VehicleTypes.GET_VEHICLE_SUBSCRIPTIONS_SUCCESS: {
      return replaceValueAtPath(state, 'subscriptions.list', payload || [])
    }
    case VehicleTypes.UPDATE_FILTER_VEHICLE_SUBSCRIPTIONS_SUCCESS: {
      return replaceValueAtPath(state, 'subscriptions.filter', payload)
    }
    case VehicleTypes.CLEAR_FILTER_VEHICLE_SUBSCRIPTIONS_SUCCESS: {
      return replaceValueAtPath(
        state,
        'subscriptions.filter',
        DEFAULT_VEHICLE_SUBSCRIPTION_FILTER
      )
    }
    // sheet users
    case VehicleTypes.GET_VEHICLE_USERS_SUCCESS: {
      return replaceValueAtPath(state, 'users.list', payload)
    }
    case VehicleTypes.GET_SYSTEM_VEHICLES_SUCCESS:
      return { ...state, systems: payload?.vehicles?.items }
    case VehicleTypes.GET_DIRECT_VEHICLES_BY_VEHICLE_ID_SUCCESS:
      return {
        ...state,
        directVehicle: {
          list: payload?.items,
          pagination: payload?.meta
        }
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default vehicle
